/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpSharedDetailWaist_item = {|
  +measurement: ?{|
    +waist: ?$ReadOnlyArray<?{| |}>;
  |};
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDetailWaist_item",
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "ItemMeasurement",
      "name": "measurement",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": "waist",
          "args": [
            {
              "kind": "Literal",
              "name": "fields",
              "value": [
                "waist"
              ],
              "type": "[measurementFieldType]"
            }
          ],
          "concreteType": "ItemDisplayMeasurementType",
          "name": "display",
          "plural": true,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "PdpSharedDetailMeasurement_measurements",
              "args": null
            }
          ],
          "storageKey": "display{\"fields\":[\"waist\"]}"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item"
};

module.exports = fragment;
